import type { HttpResult } from 'widgets-for-react'
import { getImageUrls } from '../../utils/sharepointImageUrls'
import type { Link } from '../cmsPage/cmsPageState'
import type { SearchResult } from './searchPageState'

type SearchPageData = {
  rows: {
    label: string
    title: string
    description: string
    url: string
    image?: Link
    eventDate?: Date
    publishingDate?: Date
    departmentTitle?: string
  }[]
  suggestions: string[]
  count: number
}

export const getSearchData = async (searchTerm: string, page: number, lang: string): Promise<HttpResult<SearchResult>> => {
  const res = await fetch(`/api/v1/search/pages?query=${searchTerm}&page=${page - 1}&lang=${lang}`) //goes to /en/api in english???

  if (!res.ok)
    return {
      kind: 'failed',
      status: res.status,
    }

  lang == 'nl' ? document.title = 'Zoeken | Spaarne Gasthuis' : document.title = 'Search | Spaarne Gasthuis'
  const data: SearchPageData = await res.json()
  
  return {
    kind: 'result',
    status: 200,
    value: parseResponse(data)
  }
}

const parseHit = (h: SearchPageData["rows"][number]): SearchResult["hits"][number] => ({
  label: h.label as SearchResult["hits"][number]["label"],
  title: h.title,
  description: h.description,
  image: (h.image && h.image.url) ? {
    alt: h.image.title,
    urls: getImageUrls(h.image.url),
  } : undefined,
  url: h.url,
  publishingDate: h.publishingDate && new Date(h.publishingDate),
  eventDate: h.eventDate && new Date(h.eventDate),
  departmentTitle: h.departmentTitle as SearchResult["hits"][number]["departmentTitle"]
})

const parseResponse = (data: SearchPageData): SearchResult => ({
  hits: data.rows.map(parseHit),
  suggestions: data.suggestions
})
